<template>
<svg xmlns="http://www.w3.org/2000/svg" class="tw-fill-namaGray dark:tw-fill-white" viewBox="0 0 24 24"><path d="M13.5 6.5A1.5 1.5 0 1 1 12 5a1.5 1.5 0 0 1 1.5 1.5M24 12a12 12 0 1 0-12 12h12Zm-2 0v10H12a10 10 0 1 1 10-10m-8 0a2 2 0 0 0-2-2h-2v2h2v7h2Z"/></svg>
</template>
